import type { PostgrestError } from "@supabase/supabase-js";

// ---------------------------------------------------------------------------
// Pagination
// ---------------------------------------------------------------------------
//
// PostgREST caps every response at its server `max-rows` setting (1000 on
// Supabase's defaults) — a bare `select` silently returns only the first 1000
// rows with NO error. Any "list all" read below can exceed that as the catalog
// grows, so we page through in `PAGE_SIZE` windows via `.range()` until a short
// page comes back. The builder MUST end in a STABLE, TOTAL `.order(...)` (a
// unique tiebreaker like `id`) — ordering on a non-unique column alone lets
// rows shift across page boundaries and get skipped or duplicated.
// ---------------------------------------------------------------------------

const PAGE_SIZE = 1000;

export async function fetchAllPages(
  build: (
    from: number,
    to: number,
  ) => PromiseLike<{ data: readonly unknown[] | null; error: PostgrestError | null }>,
): Promise<unknown[]> {
  const out: unknown[] = [];
  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await build(from, from + PAGE_SIZE - 1);
    if (error) throw error;
    const rows = data ?? [];
    out.push(...rows);
    if (rows.length < PAGE_SIZE) break;
  }
  return out;
}
